export enum CompanyProfileStepColor {
  Blue = 'blue',
  Empty = 'white',
  Red = 'red',
  Gray = 'gray',
}
